import { atom } from 'recoil'
import { selectorWithoutCache as selector } from 'util/RecoilWithoutCache'
import { MixContractInfoState } from './Contract'

import LocalCache, { CacheKey } from 'util/LocalCache'

import { CurrentKlinePeriodVersion, DefaultTimePanelList, IKlineListItem } from 'constants/kline'
import { getContractBitIconInfo } from 'api/common'
import { isSuccess } from 'util/Common'
import { MixContractTickerInfo } from '../entity'
// import { getAllBitIconInfo } from 'api/common'

// import { MixContractInfo, MixContractTickerInfo } from 'store/entity'

/**
 * 仅获取保证金列表
 */
export const SupportedMarginSelector = selector<{ [key: string]: string }>({
    key: 'base-support-margin-selector',
    get: ({ get }) => {
        const base = get(MixContractInfoState)
        const tokenList = base.supportMarginTokenIds
        return tokenList.reduce((map, token) => {
            map[token] = token
            return map
        }, {})
    }
})

// { symbolId: string; symbolCode: string, rose:string, last: string }
export const startList = atom<MixContractTickerInfo[]>({
    key: 'startList',
    default: []
    // =======
})

// 处理周期新增和修改 sort 问题
const fliterTimePanelList = (): Array<IKlineListItem> => {
    const klinePeriodListVersion = LocalCache.get(CacheKey.KLINE_PERIOD_VERSION)
    // 如果周期版本号不相等就代表需要更新
    if (klinePeriodListVersion !== CurrentKlinePeriodVersion) {
        // 设置为 true 代表执行更新了
        LocalCache.set(CacheKey.KLINE_PERIOD_VERSION, CurrentKlinePeriodVersion)
        // 设置默认值
        LocalCache.set(CacheKey.KLINE_PERIOD_LIST, DefaultTimePanelList)
    }
    return LocalCache.get(CacheKey.KLINE_PERIOD_LIST) || DefaultTimePanelList
}

/**
 * 收藏的k线周期state，如果没有缓存，默认使用前九个
 */
export const CollectTimeList = atom<Array<IKlineListItem>>({
    key: 'collectTimeList',
    default: fliterTimePanelList()
    // >>>>>>> origin/feature/mix-kline-period-select-20220228
})

export const MixRateListState = atom({
    key: 'all-rate-list',
    default: []
})

// 合约不再用 只有现货再用
// export const allBitIconInfoQuery = selector({
//     key: 'allBitIconInfo',
//     get: async () => {
//         const res: any = await getAllBitIconInfo()
//         if (isSuccess(res?.code) && res.data) {
//             return res.data
//         } else {
//             throw res.msg
//         }
//     }
// })

// 快速下单组件涉及的状态 合约现货共用
export const quickOrderState = atom({
    key: 'quick-order',
    default: { isQuickOrderDragging: false }
})

export type PosInfo = {
    visible: boolean
    clientX?: number
    clientY?: number
    price?: number
}
export const LimitQuickOrderPosState = atom<PosInfo>({
    key: 'limit-quick-order-pos-state',
    default: { visible: false, clientX: 0, clientY: 0 }
})

// 全部币币接口 全量纯币种信息配置接口
export const allCoinsIconInfoQuery = selector({
    key: 'all-coins-icon-info-query',
    get: async () => {
        const res: any = await getContractBitIconInfo()
        if (isSuccess(res?.code) && res.data) {
            return res.data
        } else {
            throw res.msg
        }
    }
})

/**
 * 记录币对默认的最大可批量修改的杠杆
 */
export const AdjustLeverageBatchMaxDefault = atom<number>({
    key: 'adjust-leverage-batch-max-default',
    default: 0
})

/**
 * 当前标签页是否是前台选中标签页
 * */
export const isCurrentTabState = atom<number>({
    key: 'is-current-tab-state',
    default: 1
})
